module.exports = __webpack_public_path__ + "img/avatar-voorstel-man.099d1836.jpeg";